import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Logo } from "../common/Logo";

const footerLinks = {
  product: [
    { to: "/features", labelKey: "footer.features" },
    { to: "/downloads", labelKey: "footer.downloads" },
    { to: "/changelog", labelKey: "footer.changelog" },
  ],
  resources: [
    { to: "/docs", labelKey: "footer.docs" },
    { to: "/docs/getting-started", labelKey: "footer.gettingStarted" },
    { to: "/docs/reference/api", labelKey: "footer.apiReference" },
  ],
};

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-dark-card border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1">
            <Logo className="mb-4" />
            <p className="text-warm-500 text-sm">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-warm-50 font-semibold mb-4">{t('footer.product')}</h4>
            <ul className="space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-warm-500 hover:text-warm-100 text-sm transition-colors"
                  >
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-warm-50 font-semibold mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-warm-500 hover:text-warm-100 text-sm transition-colors"
                  >
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-dark-border">
          <p className="text-warm-500 text-sm text-center">
            &copy; {new Date().getFullYear()} {t('footer.copyright')} {t('footer.allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
}
